/**
 * finds all elements in a container, including the container if matching
 */

export function findAllIn(rootElement = document.body, selector) {
    return !(rootElement instanceof HTMLElement) ? [] : [...(rootElement.matches(selector) ? [rootElement] : []), ...rootElement.querySelectorAll(':scope ' + selector)]
}